import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchSelectOption } from "../../HandleSlice/HandleSlice";

const SelectRoute = (props) => {
  const [newOption, setNewOption] = useState([]);
  const [newSpinnerState, setNewSpinnerState] = useState(false);
  const [newInputSearchValue, setNewInputSearchValue] = useState("");
  const [newArray, setNewArray] = useState(["4"]);
  const [newScrollPage, setNewScrollPage] = useState(2);
  const [changePageSpinner, setChangePageSpinner] = useState(false);
  const [newScrollFetching, setNewScrollFetching] = useState(true);
  const useRouterRef = useRef();
  const optionRef = useRef();
  const dispatch = useDispatch();
  const selectRouteSearchData = useSelector((data) => data);

  const getOptionsHandler = (event) => {
    const inputValue = event.target.value;
    setNewInputSearchValue(event.target.value);
    setNewScrollPage(2);
    setNewArray(["4"]);
    setChangePageSpinner(false);
    if (inputValue.length === 0) {
      setNewOption([{ label: "برای جستجو تایپ کنید", value: "" }]);
    }
    if (inputValue.length > 1) {
      setNewSpinnerState(true);
      axios
        .get(`${props.itemRoute}${inputValue}&per_page=10`)
        .then((res) => {
          res.data.data.data.length === 0
            ? setNewOption([{ label: "داده ای یافت نشد", value: "" }])
            : setNewOption(res.data.data.data);
        })
        .then(() => setNewSpinnerState(false))
        .catch((error) => console.log(error));
    }
  };

  const optionClickHandler = (event) => {
    const optionValue = event.target.getAttribute("value");
    dispatch(setSearchSelectOption(event.target.innerText));
    setChangePageSpinner(false);
    setNewSpinnerState(false);

    if (optionValue === "") {
      return;
    }

    useRouterRef.current.value = event.target.innerText;

    if (props.HasManyInputData) {
      props.HasManyInputData(
        props.index,
        props.HasManyKey,
        String(optionValue),
      );
    } else {
      let object = props.inputData;
      object[props.item.key] = String(optionValue);
      props.setInputData(object);
    }
    setNewOption([]);
  };

  // console.log(props)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlParamsArray = urlParams.keys();
    for (let key of urlParamsArray) {
      if (props.pageType === "search" && key === props?.item?.key) {
        useRouterRef.current.value =
          selectRouteSearchData.hamberger.searchSelectOption;
      }
    }
  }, []);

  useEffect(() => {
    if (props.pageType === "edit") {
      useRouterRef.current.value = props.editDataValue.label;
      const editSetInputData = props.inputData;
      editSetInputData[props.item.key] = props.editDataValue.value;
    }

    document.body.addEventListener("click", (event) => {
      if (!event.target.matches("." + props.machOptionsClass)) {
        setNewOption([]);
      }
    });
  }, []);
  const scrollFechtHandler = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    // setNewScrollFetching(bottom)
    if (bottom === true && newArray.length > 0) {
      setChangePageSpinner(true);
      if (newScrollFetching === true) {
        setNewScrollFetching(false);
        axios
          .get(
            `${props.itemRoute}${newInputSearchValue}&per_page=10&page=${newScrollPage}`,
          )
          .then(async (res) => {
            setNewArray(res.data.data.data);
            setChangePageSpinner(false);
            if (res.data.data.data.length > 0) {
              setNewSpinnerState(false);
              await setNewOption((prev) => [...prev, ...res.data.data.data]);
              await setNewScrollPage((prev) => prev + 1);
            }
          })
          .then(() => setNewScrollFetching(true))
          .catch((error) => {
            console.log(error);
            setChangePageSpinner(false);
          });
      }
    }
  };

  function focusHandler(event) {
    if (event.target.value.length === 0) {
      setNewOption([{ label: "برای جستجو تایپ کنید", value: "" }]);
    }
  }

  return (
    <div className="relative">
      <input
        type="text"
        className={`h-[38px] border border-edit_input_border rounded-[4px] px-3 w-full ${
          props.machOptionsClass
        } ${
          props.item.disabled !== undefined || props.item.disabled
            ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#b5b5b5] text-edit_input_text_disabled"
            : "bg-white dark:bg-[#ffffffdd] text-edit_input_text"
        }`}
        onChange={getOptionsHandler}
        ref={useRouterRef}
        disabled={props.item.disabled}
        autoComplete="off"
        onFocus={focusHandler}
      />
      <div
        className={`absolute z-[99] w-full bg-white ${
          newOption !== undefined && newOption.length !== 0
            ? "border shadow-md"
            : ""
        }`}
      >
        <ul
          className={`overflow-y-scroll ${
            newOption !== undefined && newOption.length !== 0
              ? " max-h-[140px]"
              : ""
          }`}
          onScroll={scrollFechtHandler}
        >
          {newSpinnerState ? (
            <li className="flex items-center gap-4 bg-white">
              <span className="inline-block animate-spin h-6 w-6 mr-3 rounded-[50%] bg- border-t-4 border-r-4 border-stone-500 mt-2 mb-2"></span>
              <span>در حال جستجو</span>
            </li>
          ) : (
            newOption !== undefined &&
            newOption.map((item, index) => (
              <li
                key={item.label + index}
                value={item.value}
                ref={optionRef}
                onClick={optionClickHandler}
                className={`px-[10px] py-[5px] bg-white cursor-pointer ${props.machOptionsClass} hover:bg-aside_background_menu`}
              >
                {item.label}
              </li>
            ))
          )}
        </ul>
        {changePageSpinner && (
          <div className="flex items-center justify-center gap-4 bg-white relative">
            <span className="inline-block animate-spin h-6 w-6 mr-3 rounded-[50%] bg- border-t-4 border-r-4 border-stone-500 mt-2 mb-2"></span>
            <span>در حال جستجو</span>
          </div>
        )}
      </div>
      <div className="mt-2 text-[.8rem] text-edit_input_validation">
        {props.children}
      </div>
    </div>
  );
};

export default SelectRoute;
